
const buildQueryString = (url: string, params: Record<string, string | number | boolean>) => {
  if (!params) return url;

  const query = Object.entries(params)
    .filter(([_, value]) => value != null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

  if (!query || query.length === 0) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${query}`;
};

export default buildQueryString;
